export const UPDATE_REPORT_MODAL = 'reportColumns';
